import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ConnectorProvider, ConnectorView } from './connectors.models';

export const ConnectorsActions = createActionGroup({
  source: 'Connectors',
  events: {
    'Load Connectors': emptyProps(),
    'Load Connectors Success': props<{ connectors: ConnectorView[] }>(),
    'Load Connectors Failure': props<{ error: string }>(),

    // The connectors modal is hosted once by the chats shell; anything that manages connectors opens
    // it through the store rather than by navigating.
    'Open Modal': emptyProps(),
    'Close Modal': emptyProps(),

    // Leaves the app entirely: a top-level navigation to the API, which redirects to the provider.
    'Connect Provider': props<{ provider: ConnectorProvider }>(),

    'Disconnect Provider': props<{ provider: ConnectorProvider }>(),
    'Disconnect Provider Success': props<{ provider: ConnectorProvider }>(),
    'Disconnect Provider Failure': props<{
      provider: ConnectorProvider;
      error: string;
    }>(),

    /** Callback outcome; map URL-supplied failure codes to translated messages. */
    'Authorization Returned': props<{
      provider: ConnectorProvider;
      reason: string | null;
    }>(),
  },
});
